import React, { useState } from 'react';
import { Box, Button, FormControl, FormLabel, Input, Heading, VStack, useToast } from '@chakra-ui/react';
import BarbeirosImg from '../../assets/Barber.jpeg';
import { supabase } from '../../services/supabaseClient';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (error) {
      toast({ title: 'Erro no login', description: error.message, status: 'error', duration: 4000, isClosable: true });
    } else {
      navigate('/admin/dashboard');
    }
  };

  return (
  <Box
    minH="100vh"
    w="100vw"
    bgImage={`url(${BarbeirosImg})`}
    bgSize="cover"
    bgPosition="center"
    display="flex"
    alignItems="center"
    justifyContent="center"
    position="relative"
    _before={{
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      bg: 'rgba(0,0,0,0.65)',
      zIndex: 1
    }}
  >
    <VStack
      spacing={8}
      p={{ base: 6, md: 12 }}
      borderRadius="2xl"
      boxShadow="2xl"
      w="95%"
      maxW="380px"
      zIndex={2}
      bg={{
        base: 'rgba(30,30,30,0.55)',
        md: 'rgba(30,30,30,0.45)'
      }}
      backdropFilter="blur(14px) saturate(120%)"
      border="1px solid rgba(255,255,255,0.08)"
    >
      <Heading
        color="yellow.400"
        size="xl"
        letterSpacing="wider"
        fontWeight="extrabold"
        textShadow="0 2px 8px #0009"
        textAlign="center"
      >
        Login
      </Heading>
      <form style={{ width: '100%' }} onSubmit={handleLogin}>
        <FormControl mb={5} isRequired>
          <FormLabel color="white" fontWeight="bold" letterSpacing="wide">Email</FormLabel>
          <Input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            autoFocus
            bg="rgba(255,255,255,0.10)"
            color="yellow.200"
            border="none"
            borderRadius="lg"
            fontWeight="semibold"
            _placeholder={{ color: 'gray.300', fontWeight: 'normal' }}
            _focus={{ bg: 'rgba(255,255,255,0.18)' }}
            boxShadow="sm"
          />
        </FormControl>
        <FormControl mb={7} isRequired>
          <FormLabel color="white" fontWeight="bold" letterSpacing="wide">Senha</FormLabel>
          <Input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            bg="rgba(255,255,255,0.10)"
            color="yellow.200"
            border="none"
            borderRadius="lg"
            fontWeight="semibold"
            _placeholder={{ color: 'gray.300', fontWeight: 'normal' }}
            _focus={{ bg: 'rgba(255,255,255,0.18)' }}
            boxShadow="sm"
          />
        </FormControl>
        <Button
          type="submit"
          w="100%"
          size="lg"
          colorScheme="yellow"
          fontWeight="bold"
          fontSize="lg"
          borderRadius="xl"
          boxShadow="0 4px 16px #0006"
          isLoading={loading}
          loadingText="Entrando"
          _hover={{ bg: 'yellow.500', color: 'gray.900' }}
        >
          Entrar
        </Button>
      </form>
      <Box pt={2}>
        <span style={{ color: '#eee8', fontSize: '0.90em', letterSpacing: '1px' }}>
          Feito com ❤️ Mi
        </span>
      </Box>
    </VStack>
  </Box>
);
};

export default LoginPage;
